import FeedActionBar from './FeedActionBar';

export default FeedActionBar;
